import { Card, Col, Modal } from 'antd';
import styled from 'styled-components';

export const ContainerChart = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
`;

export const Item = styled.label`
	display: block;
`;

export const ItemValue = styled(Item)`
	padding-top: 10px;
	font-weight: bold;
`;

export const ModalCard = styled(Card)`
	text-align: center;
	margin-top: 10px;
	border-radius: 17px;
	min-width: 200px;
	max-width: 200px;
	height: 115px;
	background: #f5f5f5;
	color: #262626;
	margin-bottom: 0px;

	svg {
		fill: #262626;
		font-size: 25px;
	}
	.message-card {
		font-size: 10px;
		color: grey;
	}
	.title-card {
		margin: 8px 0 0 0;
		padding: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.liberty-mutual-icon {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.liberty-mutual-icon-hovered {
		display: none;
	}

	@media (min-height: 800px) {
		margin-bottom: 20px;
		min-width: 211px;
		max-width: 211px;
		height: 130px;
		svg {
			fill: #262626;
			font-size: 40px;
			width: 1em;
			height: 1em;
		}
		.message-card {
			font-size: 13px;
			color: grey;
		}
		.title-card {
			margin: 10px 0 0 0;
			padding: 0;
			font-weight: 600;
		}
	}
	&:hover {
		.liberty-mutual-icon {
			display: none;
		}
		.liberty-mutual-icon-hovered {
			display: flex;
			flex-direction: row;
			justify-content: center;
		}
		background: #2f54eb;
		color: #fff;
		cursor: pointer;
		svg {
			fill: #fff;
		}
		.message-card {
			color: #fff;
		}
	}

	& .ant-card-body {
		padding: 24px 12px;
	}
`;

export const ModalBorder = styled(Modal)`
	.ant-modal-content {
		border-radius: 30px;
		.title-modal {
			font-size: 35px;
			text-align: center;
		}

		@media (min-height: 800px) {
			padding-top: 25px;
			.title-modal {
				font-size: 35px;
				text-align: center;
				margin: 0 0 10px 0;
			}
			.paragraph-modal {
				margin: 0 0 45px 0;
			}
		}
	}
`;

export const ModalColumn = styled(Col)`
	overflow-y: auto;
	height: 395px;

	@media (min-height: 800px) {
		height: 500px;
	}

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb {
		background: #4156f2;
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;
